<div class="dynamic-field form-input" [formGroup]="group">
  <rx-icon [name]="config.icon" size="12" [color]="config?.iconColor"></rx-icon>
  <input [formControlName]="config.name" [type]="config.type" [placeholder]="config.placeholder" autocomplete="off" />
</div>
